import React from 'react';
import PropTypes from 'prop-types';

import FilterField from "./FilterField";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


function SourceFilterField(props) {
	let {sourceOptions, changeHandler, includeReset} = props;

	return sourceOptions && sourceOptions.length > 1 ?
		<FilterField
			includeSelectAll
			includeReset={includeReset}
			options={sourceOptions}
			name="source"
			menuTitle="Sources"
			selectAllTitle="All Sources"
			changeHandler={changeHandler}
			startIcon={<FontAwesomeIcon icon={["fal", "signal"]} transform={{ rotate: 270 }} />} /> : null;
}

SourceFilterField.propTypes = {
	changeHandler: PropTypes.func.isRequired,
	sourceOptions: PropTypes.array,
	includeReset: PropTypes.bool
};

export default SourceFilterField;